// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".back-drop[data-v-146dbc2d]{align-items:center;background-color:rgba(40,44,74,.25);bottom:0;display:flex;justify-content:center;left:0;position:fixed;right:0;top:0;z-index:10}.back-drop--hidden[data-v-146dbc2d]{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
